// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1PfP_","footer":"ModalFilter_footer__xV1w0"};